import { render } from "./BookDetailView.vue?vue&type=template&id=2b8ec392"
import script from "./BookDetailView.vue?vue&type=script&lang=js"
export * from "./BookDetailView.vue?vue&type=script&lang=js"

import "./BookDetailView.vue?vue&type=style&index=0&id=2b8ec392&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__